import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, catchError, debounceTime, distinctUntilChanged, map, switchMap, takeWhile } from 'rxjs';

import { SuggestService } from 'ish-core/services/suggest/suggest.service';
import { mapToPayloadProperty, whenTruthy } from 'ish-core/utils/operators';

import { customSuggestSearch, customSuggestSearchSuccess } from './custom-search.actions';

@Injectable()
export class CustomSearchEffects {
  constructor(private actions$: Actions, private suggestService: SuggestService) {}

  customSuggestSearch$ = createEffect(() =>
    this.actions$.pipe(
      takeWhile(() => !SSR),
      ofType(customSuggestSearch),
      mapToPayloadProperty('searchTerm'),
      debounceTime(400),
      distinctUntilChanged(),
      whenTruthy(),
      switchMap(searchTerm =>
        this.suggestService.customSearch(searchTerm).pipe(
          map(suggests => customSuggestSearchSuccess({ searchTerm, suggests })),
          catchError(() => EMPTY)
        )
      )
    )
  );
}
